// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, Outlet, useNavigate, Link } from 'react-router-dom';
import PDV from './pages/PDV/PDV';
import HistoricoVendas from './pages/HistoricoVendas/HistoricoVendas';
import AdminProdutos from './pages/AdminProdutos/AdminProdutos';
import Financas from './pages/Financas/Financas';
import LoginPage from './pages/Auth/LoginPage';
import AdminUsuarios from './pages/AdminUsuarios/AdminUsuarios';

import { AuthProvider, useAuth } from './auth/AuthContext';
import { logoutUser } from './auth/AuthService';
import AdminRoute from './auth/AdminRoute';

import './App.css';

// Componente auxiliar para proteger rotas (verifica se está logado)
const PrivateRoute = () => {
  const { currentUser, loadingAuth } = useAuth();
  if (loadingAuth) {
    return (
      <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', fontSize: '2em', color: '#020202'}}>
        Carregando...
      </div>
    );
  }
  return currentUser ? <Outlet /> : <Navigate to="/login" replace />;
};

// Componente de Layout Final
const ProtectedLayout = () => {
  const { currentUser, userRole } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await logoutUser();
      navigate('/login');
    } catch (error) {
      alert('Erro ao fazer logout. Tente novamente.');
    }
  };

  return (
    <>
      <nav className="navbar">
        <span className="navbar-brand">Meu PDV</span>
        
        <div className="nav-links">
          {userRole === 'admin' ? (
            <>
              <Link to="/pdv" className="nav-link">PDV</Link>
              <Link to="/historico" className="nav-link">Histórico</Link>
              <Link to="/admin/produtos" className="nav-link">Gerir Produtos</Link>
              <Link to="/financas" className="nav-link">Finanças</Link>
              <Link to="/admin/usuarios" className="nav-link">Gerir Utilizadores</Link>
            </>
          ) : (
            <>
              <Link to="/pdv" className="nav-link">PDV</Link>
              <Link to="/historico" className="nav-link">Histórico</Link>
            </>
          )}
        </div>

        <div className="user-info">
          <span>Olá, {currentUser?.email || 'Usuário'}</span>
          <button onClick={handleLogout} className="logout-btn">
            Sair
          </button>
        </div>
      </nav>
      
      <Outlet />
    </>
  );
};


function App() {
  return (
    <Router>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<LoginPage />} />

          <Route element={<PrivateRoute />}>
            <Route element={<ProtectedLayout />}>
              <Route path="/" element={<PDV />} />
              <Route path="/pdv" element={<PDV />} />
              <Route path="/historico" element={<HistoricoVendas />} />
              <Route element={<AdminRoute />}>
                <Route path="/admin/produtos" element={<AdminProdutos />} />
                <Route path="/financas" element={<Financas />} />
                <Route path="/admin/usuarios" element={<AdminUsuarios />} />
              </Route>
            </Route>
          </Route>

          <Route path="*" element={<div><h1>404 - Página Não Encontrada</h1><p>Verifique o endereço.</p></div>} />
        </Routes>
      </AuthProvider>
    </Router>
  );
}

export default App;
